(function () {
  if (customElements.get('one-client-timeline')) return;

  var DESKTOP_BREAKPOINT = 750;

  class OneClientTimeline extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('[data-timeline-container]');
      if (!this.container) return;

      this.phases = Array.from(
        this.container.querySelectorAll('[data-timeline-phase]'),
      );
      this.pills = Array.from(
        this.container.querySelectorAll('[data-timeline-pill]'),
      );
      this.connectors = Array.from(
        this.container.querySelectorAll('[data-timeline-connector]'),
      );

      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._autoCycleStarted = false;
      this._autoCycleTimer = null;
      this._observer = null;

      this.phases.forEach(
        function (phase) {
          phase.addEventListener('mouseenter', this._onMouseEnter);
        }.bind(this),
      );

      if (
        window.innerWidth >= DESKTOP_BREAKPOINT &&
        this.phases.length > 1 &&
        'IntersectionObserver' in window
      ) {
        this._observer = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting && !this._autoCycleStarted) {
                this._autoCycleStarted = true;
                if (this._observer) {
                  this._observer.disconnect();
                  this._observer = null;
                }
                this._startAutoCycle();
                break;
              }
            }
          }.bind(this),
          { rootMargin: '0px 0px -20% 0px', threshold: 0 },
        );
        this._observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.phases.forEach(
        function (phase) {
          phase.removeEventListener('mouseenter', this._onMouseEnter);
        }.bind(this),
      );
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      this._cancelAutoCycle();
    }

    _onMouseEnter(e) {
      if (window.innerWidth < DESKTOP_BREAKPOINT) return;

      this._cancelAutoCycle();

      var phase = e.currentTarget;
      var index = parseInt(phase.getAttribute('data-timeline-phase'), 10);
      this._activate(index);
    }

    _startAutoCycle() {
      var sequence = [];
      for (var i = 1; i < this.phases.length; i++) sequence.push(i);
      sequence.push(0);

      var step = 0;
      var self = this;
      var tick = function () {
        self._activate(sequence[step]);
        step++;
        if (step < sequence.length) {
          self._autoCycleTimer = setTimeout(tick, 750);
        } else {
          self._autoCycleTimer = null;
        }
      };
      this._autoCycleTimer = setTimeout(tick, 750);
    }

    _cancelAutoCycle() {
      if (this._autoCycleTimer) {
        clearTimeout(this._autoCycleTimer);
        this._autoCycleTimer = null;
      }
    }

    _activate(activeIndex) {
      this.phases.forEach(function (p) {
        p.classList.remove('is-active');
      });
      this.phases[activeIndex].classList.add('is-active');
      this._positionConnectors(activeIndex);
    }

    _positionConnectors(activeIndex) {
      for (var i = 0; i < this.connectors.length; i++) {
        var conn = this.connectors[i];
        var wasVisible = conn.classList.contains('is-visible');
        conn.classList.remove('is-first', 'is-last');

        if (i < activeIndex) {
          var currentPill = this.pills[i];
          var nextPill = this.pills[i + 1];
          var currentRect = currentPill.getBoundingClientRect();
          var nextRect = nextPill.getBoundingClientRect();
          var header = conn.parentElement;
          var headerRect = header.getBoundingClientRect();

          conn.style.left = currentRect.right - headerRect.left + 6 + 'px';
          conn.style.width = nextRect.left - currentRect.right - 12 + 'px';
          conn.style.setProperty('--connector-delay', wasVisible ? '0s' : '0s');
          conn.classList.add('is-visible');

          if (i === 0) conn.classList.add('is-first');
          if (i === this.connectors.length - 1) conn.classList.add('is-last');
        } else {
          conn.classList.remove('is-visible');
        }
      }
    }
  }

  customElements.define('one-client-timeline', OneClientTimeline);
})();
